import { render, staticRenderFns } from "./DetailConsignment.vue?vue&type=template&id=56ca6b43&scoped=true"
import script from "./DetailConsignment.vue?vue&type=script&lang=ts"
export * from "./DetailConsignment.vue?vue&type=script&lang=ts"
import style0 from "./DetailConsignment.vue?vue&type=style&index=0&id=56ca6b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca6b43",
  null
  
)

export default component.exports